<script>
export default {
    name: 'ReviewMixin',
    methods: {
        async getAttachments(attachmentCallPromises) {
            this.updateLoading(true)
            let attachments = []
            for (let index in attachmentCallPromises) {
                const [error, response] = await this.toCall(attachmentCallPromises[index].call)
                if (error) {
                    this.updateLoading(false)
                    this.showErrorModalGlobalFromErrorResponse(error)
                    return
                }
                response.forEach(attachment => {
                    attachment.attachmentEntityType = attachmentCallPromises[index].entityType
                    attachments.push(attachment)
                })
            }
            this.updateLoading(false)
            return attachments
        }
    }
}
</script>
